module.exports = __webpack_public_path__ + "static/img/science.e60e4ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/science.jpg
// module id = oa8H
// module chunks = 16